<template>
  <div class="LearnSlider">

    <div class="LearnSlider-header t-small"
      v-if="content.text"
      v-html="content.text">
    </div>

    <carousel class="LearnSlider-carousel"
      ref="carousel"
      :initial-index="goToIndex">

      <div class="LearnSlider-item"
        v-for="(item, index) in content.options"
        @click="handleItemClick(index)">

        <component :is="item.type"
          :image="item.image"
          :content="item"
          :disabled="index !== selectedIndex"/>

      </div>

    </carousel>

    <div class="LearnSlider-footer t-small"
      v-if="content.footer"
      v-html="content.footer">
    </div>

  </div>
</template>

<script>
import Carousel from 'components/Carousel'
import Flipper from 'components/Learn/Flipper'
import Revealer from 'components/Learn/Revealer'

export default {
  name: 'LearnSlider',

  components: {
    Carousel,
    Flipper,
    Revealer
  },

  props: {
    content: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      selectedIndex: 0,
      goToIndex: 0
    }
  },

  mounted () {
    this.$nextTick(this.init)
  },

  beforeDestroy () {
    this.destroy()
  },

  methods: {
    init () {
      this.addEventListeners()
    },

    destroy () {
      this.removeEventListeners()
    },

    /**
     * Add event listeners
     */
    addEventListeners () {
      this.$refs.carousel.$el.addEventListener('selected', this.handleSelected)
    },

    /**
     * Remove event listeners
     */
    removeEventListeners () {
      this.$refs.carousel.$el.removeEventListener('selected', this.handleSelected)
    },

    /**
     * Handle carousel selected event
     */
    handleSelected (event) {
      this.selectedIndex = event.detail.index
    },

    /**
     * Handle click event on an item
     * @param  {Integer} index
     */
    handleItemClick (index) {
      if (index === this.selectedIndex) return
      this.goToIndex = index
    }
  }
}
</script>

<style>
.LearnSlider {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  text-align: center;
}

.LearnSlider-header {
  position: relative;
  z-index: 1;
  width: 652px;
}

.LearnSlider-carousel {
  width: 930px;
  height: 371px;
  overflow: hidden;
}

.LearnSlider-item {
  height: 371px;
}

.LearnSlider-footer {
  position: relative;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// LearnSlider.vue?ca673344